import { useMemo, useSyncExternalStore } from 'react';
import { JsonPointerPath } from 'types/dynamic-forms/JsonPointerPath';
import { useDocumentStore } from './useDocumentStore';

export default function useNestedErrors(path: JsonPointerPath): string[] {
  const store = useDocumentStore();

  const callbacks = useMemo(() => {
    const getActualState = () => {
      return Array.from(store.getErrorMessagesIncludingNested(path));
    };

    let prevState = getActualState();

    return {
      subscribe: (callback: () => void) => {
        const memoizedCallback = () => {
          const newState = getActualState();
          const isSameState = prevState.length === newState.length && prevState.every((el, i) => Object.is(el, newState[i]));
          if (!isSameState) {
            prevState = newState;
            callback();
          }
        };

        return store.addDataChangedListener(memoizedCallback);
      },
      getState: () => prevState,
    };
  }, [store, ...path]);
  const state = useSyncExternalStore(callbacks.subscribe, callbacks.getState);

  return state;
}
